if (!customElements.get('foamslot-slideshow')) {
  class FoamSlotSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.buttons = Array.from(this.querySelectorAll('[data-slide-button]'));
      this.toggle = this.querySelector('[data-slideshow-toggle]');
      this.caption = this.querySelector('[data-slide-caption]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.paused = false;

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.show(Number(button.dataset.slideButton));
          this.restart();
        });
      });

      this.toggle?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.paused ? this.stop() : this.start();
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => {
        if (!this.paused) this.start();
      });

      this.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('[data-slide-index]');
        if (selected) this.show(Number(selected.dataset.slideIndex));
        this.stop();
      });

      this.addEventListener('shopify:block:deselect', () => {
        if (!this.paused) this.start();
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.buttons.forEach((button, index) => button.setAttribute('aria-selected', String(index === this.index)));
      if (this.caption) {
        const label = this.buttons[this.index]?.getAttribute('aria-label');
        if (label) this.caption.textContent = label;
      }
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused) return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.speed) || 5000);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = undefined;
    }

    restart() {
      if (!this.paused) this.start();
    }
  }

  customElements.define('foamslot-slideshow', FoamSlotSlideshow);
}
